import { ProcessField } from 'types/dataTableTypes';
import React from 'react';
import { DarwinListView } from 'components/darwin-ui';
import { useSystemFieldColumns } from 'hooks/dataTable/useFieldColumns';
import { useEmptyState } from 'hooks/dataTable/useEmptyState';
import {
  DTablePaginationConfig,
  DTableFilterValue,
  DTableSorterResult,
} from '@darwin-ui';

interface SystemFieldsTableProps {
  systemFields: ProcessField[];
  isLoading: boolean;
  categoryName: string;
  // Table control props
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
  onChange?: (
    pagination: DTablePaginationConfig,
    filters: Record<string, DTableFilterValue | null>,
    sorter:
      | DTableSorterResult<ProcessField>
      | DTableSorterResult<ProcessField>[]
  ) => void;
}

export const SystemFieldsTable: React.FC<SystemFieldsTableProps> = ({
  systemFields,
  isLoading,
  categoryName,
  searchQuery,
  setSearchQuery,
  onChange,
}) => {
  // Get columns for system fields
  const columns = useSystemFieldColumns(searchQuery);

  // Empty state text for when there are no system fields
  const emptyText = useEmptyState.useSystemFieldsEmptyState(
    systemFields,
    systemFields
  );

  return (
    <DarwinListView<ProcessField>
      data={systemFields}
      isLoading={isLoading}
      columns={columns}
      emptyText={emptyText}
      header={{ title: categoryName, setSearchQuery }}
      table={{ onChange, scrollable: false }}
    />
  );
};
